var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Audience } from "./types";
export var LIONBRIDGE_OIDC_ACR = "lionbridge_oidc";
var libConfig = {
    apapiUrl: "",
    aud: Audience.ANNOTATION_PLATFORM,
    defaultLogoutRedirectUrl: "",
    loginUrl: "",
    passwordResetUrl: "",
    bioAuthUrl: "",
    telusInternationalOrgId: "",
    employeeEmailDomains: ["@telusinternational.com", "@willowtreeapps.com"],
};
export var PARAMS = {
    password_reset_token: "password_reset_token",
    redirect: "redirect",
};
export function updateAuthConfig(config) {
    config = Object.assign({}, config);
    Object.assign(libConfig, config);
}
export function getAuthConfig() {
    var defaultLogoutRedirectUrl = libConfig.defaultLogoutRedirectUrl, contributorLogoutRedirectUrl = libConfig.contributorLogoutRedirectUrl, employeeLogoutRedirectUrl = libConfig.employeeLogoutRedirectUrl, tokenStorageLocation = libConfig.tokenStorageLocation;
    return __assign(__assign({}, libConfig), { employeeLogoutRedirectUrl: employeeLogoutRedirectUrl || defaultLogoutRedirectUrl, contributorLogoutRedirectUrl: contributorLogoutRedirectUrl || defaultLogoutRedirectUrl, tokenStorageLocation: tokenStorageLocation || "inMemory" });
}
var CONTRIBUTOR_ROLES = ["organization_user", "contributor"];
export default {
    getAuthConfig: getAuthConfig,
    updateAuthConfig: updateAuthConfig,
    LIONBRIDGE_OIDC_ACR: LIONBRIDGE_OIDC_ACR,
    CONTRIBUTOR_ROLES: CONTRIBUTOR_ROLES,
};
